import {Fragment, useRef} from 'react'
import utils from '@eitje/utils'
import {formatCssVars} from '../../helpers'
import {FilterProvider as _FilterProvider} from '../filters/context'
import {Layout} from '../layout'
import {useTopOffset} from './use_top_offset'
import {useHeaderHeight} from './use_header_height'
import {PageContext} from './page_context'
import _ from 'lodash'
import './styles/index.less'

const {Provider} = PageContext

export const PageLayout = ({
	children,
	state,
	name,
	core,
	footers,
	headers,
	bodyLayoutProps,
	bodyBottomPadding = 48,
	BodyComponent = Layout,
	unsetPagePadding,
	bodyWidth,
	id,
	background,

	// Wraps the PageLayout with the Filters provider; you may also wrap it manually.
	filterProps,

	className,
	floating,
	...rest
}) => {
	id = id || `${name}-page`
	const pageRef = useRef()
	const headerRef = useRef()
	const topOffset = useTopOffset(pageRef)
	const headerHeight = useHeaderHeight(headerRef, floating)
	const bodyHeight = `calc(100vh - ${topOffset}px)`
	const layoutClassName = name && _.kebabCase(`${name}-page-layout`)
	const classNames = utils.makeCns(
		'page-layout',
		layoutClassName,
		className,
		unsetPagePadding && 'unset-page-padding',
		floating && 'floating',
	)
	const value = {...state, bodyWidth, floating, headerHeight, core: core || name}
	const styles = formatCssVars({'body-bottom-padding': bodyBottomPadding, 'page-top-offset': topOffset})
	const InnerBodyWrapper = bodyWidth ? Layout : Fragment
	const outerBodyProps = bodyWidth ? {} : bodyLayoutProps
	const innerBodyProps = bodyWidth ? bodyLayoutProps : {}

	// all bodyWidth ternary's can potentially be removed by creating two page layout variants (full width and fixed width)
	const headerWidth = bodyWidth || '100%'
	const maxWidth = 'calc(100vw - 48px)'
	const minWidth = 700

	const FilterProvider = filterProps ? _FilterProvider : Fragment
	const _filterProps = filterProps ? {name, fullScreen: !bodyWidth, ...filterProps} : {}

	return (
		<FilterProvider {..._filterProps}>
			<Provider value={value}>
				<Layout
					id={id}
					ref={pageRef}
					className={classNames}
					direction="vertical"
					horizontal="center"
					height={bodyHeight}
					gap={0}
					background={background}
					colorSet={false}
				>
					{headers && (
						<Layout
							ref={headerRef}
							direction="vertical"
							className="page-headers"
							width={headerWidth}
							gap={0}
							maxWidth={bodyWidth && maxWidth}
							minWidth={bodyWidth && minWidth}
						>
							{headers}
						</Layout>
					)}
					<BodyComponent
						grow
						className="page-body"
						direction="vertical"
						horizontal="center"
						gap={0}
						maxWidth="100vw"
						width="full"
						relative
						style={styles}
						{...outerBodyProps}
						{...rest}
					>
						<InnerBodyWrapper
							className="centered-page-body-content"
							width={bodyWidth}
							maxWidth={maxWidth}
							minWidth={minWidth}
							height="full"
							direction="vertical"
							horizontal="center"
							{...innerBodyProps}
						>
							{children}
						</InnerBodyWrapper>
					</BodyComponent>
					{footers && (
						<Layout className="page-footers" width="full" gap={0}>
							{footers}
						</Layout>
					)}
				</Layout>
			</Provider>
		</FilterProvider>
	)
}
